// extracted by mini-css-extract-plugin
export var blockContent = "traffic-block-module--blockContent--f94ff";
export var buttonNoStyle = "traffic-block-module--buttonNoStyle--8b186";
export var linePicto = "traffic-block-module--linePicto--5deba";
export var perturbationPictogram = "traffic-block-module--perturbationPictogram--05c50";
export var pictoChild = "traffic-block-module--pictoChild--08909";
export var pictoChildSvg = "traffic-block-module--pictoChildSvg--da07d";
export var trafficBlock = "traffic-block-module--trafficBlock--03e79";